/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react'

import AnnotationCard from './components/AnnotationCard'
import AnnotationView from './components/AnnotationView'
import { AdvancedAnnotation } from '../../types'

interface TemplateAnnotationProps {
    mode?: string
    expanded?: boolean
    event?: AdvancedAnnotation
    onClick: (event: AdvancedAnnotation | undefined) => void
    onEdit: (event: AdvancedAnnotation, FormConfigs: FormConfigs) => void
    onDelete: (event: AdvancedAnnotation) => void
}

const TemplateAnnotation: React.FC<TemplateAnnotationProps> = (props: TemplateAnnotationProps) => {
    return props?.expanded ? (
        <AnnotationView
            event={props?.event}
            mode={props?.mode}
            callbackEdit={props?.onEdit}
            callbackDelete={props?.onDelete}
        />
    ) : (
        <AnnotationCard event={props?.event} mode={props?.mode} onClick={props?.onClick} />
    )
}

export const TemplateAnnotationRenderer = (event: AdvancedAnnotation): Record<string, unknown> => {
    if (event.__type === 'advanced_annotations' && event.__src === 'advanced_annotation') {
        return {
            priority: 99,
            component: TemplateAnnotation
        }
    }

    return {}
}

export default TemplateAnnotationRenderer
